import React from "react";
import Input from "../../../../../Components/Common/Input";
import DateInput from "../../../../../Components/Common/DateInput";
import TimeInput from "../../../../../Components/Common/TimeInput";
import ImageSelector from "../../../../../Components/Common/ImageSelector";

const LiveClassItemsForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
}) => {
  // Extract hours and minutes from formData.duration (if exists)
  const [hours, minutes] = formData.duration?.split(":") || ["", ""];

  // Handle hours and minutes change
  const handleTimeChange = (name, value) => {
    // Ensure valid input (only numbers)
    if (!/^\d*$/.test(value)) return;

    // Restrict minutes to 0-59
    if (name === "minutes" && (value > 59 || value.length > 2)) return;

    // Update formData.duration as "HH:MM"
    const newTime =
      name === "hours"
        ? `${value}:${minutes || "00"}`
        : `${hours || "0"}:${value}`;
    onChange("duration", newTime);
  };
  const handleDateChange = (name, value) => {
    if (onChange) {
      onChange(name, value?.startDate);
      onChange(name, value?.endDate);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Title"
        type="text"
        name="title"
        value={formData.title}
        onChange={onChange}
        placeholder="Enter package title"
        error={errors.title}
        required
      />
      <Input
        label="Description"
        type="text"
        name="description"
        value={formData.description}
        onChange={onChange}
        placeholder="Enter description"
        error={errors.description}
      />
      <DateInput
        label="Date"
        type="text"
        name="date"
        value={{
          startDate: formData?.date ? formData?.date : null,
          endDate: formData?.date ? formData?.date : null,
        }}
        onChange={handleDateChange}
        placeholder="Enter date"
        error={errors.date}
        required
      />
      <TimeInput
        label="Time"
        name="time"
        value={formData.time}
        onChange={onChange}
        required
        error={errors.time}
        className="w-full"
      />
      <div className="flex gap-2">
        <Input
          label="Hours"
          type="number"
          name="hours"
          value={hours}
          onChange={handleTimeChange}
          placeholder="HH"
          min={0}
          error={errors.duration}
          required
        />
        <Input
          label="Minutes"
          type="number"
          name="minutes"
          value={minutes}
          onChange={handleTimeChange}
          placeholder="MM"
          min={0}
          max={59}
          error={errors.duration}
          required
        />
      </div>

      <Input
        label="Instructor"
        type="text"
        name="instructor"
        value={formData.instructor}
        onChange={onChange}
        placeholder="Enter instructor details"
        error={errors.instructor}
      />
      <Input
        label="Meeting Link"
        type="text"
        name="meetingLink"
        value={formData.meetingLink}
        onChange={onChange}
        placeholder="Enter meeting link"
        error={errors.meetingLink}
      />
      {/* <Input
        label="Recording Link"
        type="text"
        name="recordingLink"
        value={formData.recordingLink}
        onChange={onChange}
        placeholder="Enter recording link"
        error={errors.recordingLink}
      /> */}
      <ImageSelector
        label="Upload Recording"
        name="recordingLink"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.recordingLink}
      />
    </form>
  );
};

export default LiveClassItemsForm;
